// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file api/scribe/svc_note_list.proto (package com.diagnocat.scribe, syntax proto3)
/* eslint-disable */

import { proto3 } from "@bufbuild/protobuf";
import { DocumentTemplateSummary, NoteList, NoteListItem } from "../../model/dto_scribe_catalog_pb.js";

/**
 * @generated from message com.diagnocat.scribe.GetNoteListReq
 */
export const GetNoteListReq = proto3.makeMessageType(
  "com.diagnocat.scribe.GetNoteListReq",
  () => [
    { no: 1, name: "ListID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.GetNoteListResp
 */
export const GetNoteListResp = proto3.makeMessageType(
  "com.diagnocat.scribe.GetNoteListResp",
  () => [
    { no: 1, name: "List", kind: "message", T: NoteList },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.ListNoteListsReq
 */
export const ListNoteListsReq = proto3.makeMessageType(
  "com.diagnocat.scribe.ListNoteListsReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "IDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "IncludeDeleted", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 100, name: "Offset", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
    { no: 101, name: "Limit", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.ListNoteListsResp
 */
export const ListNoteListsResp = proto3.makeMessageType(
  "com.diagnocat.scribe.ListNoteListsResp",
  () => [
    { no: 1, name: "Lists", kind: "message", T: NoteList, repeated: true },
    { no: 2, name: "Total", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.CreateNoteListReq
 */
export const CreateNoteListReq = proto3.makeMessageType(
  "com.diagnocat.scribe.CreateNoteListReq",
  () => [
    { no: 1, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "Items", kind: "message", T: NoteListItem, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.CreateNoteListResp
 */
export const CreateNoteListResp = proto3.makeMessageType(
  "com.diagnocat.scribe.CreateNoteListResp",
  () => [
    { no: 1, name: "List", kind: "message", T: NoteList },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.UpdateNoteListReq
 */
export const UpdateNoteListReq = proto3.makeMessageType(
  "com.diagnocat.scribe.UpdateNoteListReq",
  () => [
    { no: 1, name: "ListID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "BaseRevision", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "Name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "Description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "Items", kind: "message", T: NoteListItem, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.UpdateNoteListResp
 */
export const UpdateNoteListResp = proto3.makeMessageType(
  "com.diagnocat.scribe.UpdateNoteListResp",
  () => [
    { no: 1, name: "List", kind: "message", T: NoteList },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.DeleteNoteListReq
 */
export const DeleteNoteListReq = proto3.makeMessageType(
  "com.diagnocat.scribe.DeleteNoteListReq",
  () => [
    { no: 1, name: "ListID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.DeleteNoteListResp
 */
export const DeleteNoteListResp = proto3.makeMessageType(
  "com.diagnocat.scribe.DeleteNoteListResp",
  [],
);

/**
 * @generated from message com.diagnocat.scribe.RestoreNoteListReq
 */
export const RestoreNoteListReq = proto3.makeMessageType(
  "com.diagnocat.scribe.RestoreNoteListReq",
  () => [
    { no: 1, name: "ListID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.RestoreNoteListResp
 */
export const RestoreNoteListResp = proto3.makeMessageType(
  "com.diagnocat.scribe.RestoreNoteListResp",
  [],
);

/**
 * @generated from message com.diagnocat.scribe.ListNoteListUsageReq
 */
export const ListNoteListUsageReq = proto3.makeMessageType(
  "com.diagnocat.scribe.ListNoteListUsageReq",
  () => [
    { no: 1, name: "ListID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.scribe.ListNoteListUsageResp
 */
export const ListNoteListUsageResp = proto3.makeMessageType(
  "com.diagnocat.scribe.ListNoteListUsageResp",
  () => [
    { no: 1, name: "Templates", kind: "message", T: DocumentTemplateSummary, repeated: true },
  ],
);

